import { defineComponent as _defineComponent } from 'vue'
import { computed, useContext, useStore } from '@nuxtjs/composition-api';
import FilterList from './FilterList.vue';
import DropdownMenu from '~/components/DropdownMenu.vue';
import { getFacetDetails, getFacetsForLocale } from '~/composables/search/useSearch';
import { State } from '~/store';
import { ExperimentTypes } from '~/types/experiments';

type FilterItem = Record<string, Record<string, number>>;

interface Props {
  filters?: FilterItem;
  selectedFilters: Record<string, string[]>;
}

interface Emits {
  (event: 'filter:update', filterKey: string, filterLabel: string, e: Event): void;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'FilterParent',
  props: {
    filters: null,
    selectedFilters: null
  },
  emits: ["filter:update"],
  setup(__props: any) {

const props = __props as {
  filters?: FilterItem;
  selectedFilters: Record<string, string[]>;
};

const $store = useStore<State>();
const { $isFlagOn } = useContext();
const location = computed(() => $store.state.location);




const showIndividualDropdownForFilter = (label: string): boolean => {
  const singleFilters = [
    $isFlagOn(ExperimentTypes.NewFilterAttribute)
      ? 'filter-learning-area'
      : `learning-area-${location.value.secondary}`,
    'year-level',
    $isFlagOn(ExperimentTypes.NewFilterAttribute) ? 'filter-resource-type' : 'postTypeTitle',
  ];
  return singleFilters.some(filter => label.includes(filter));
};

const getNumSelected = (...filterKeys: string[]) => {
  return filterKeys.reduce(
    (acc, filterKey) => acc + (props.selectedFilters[filterKey]?.length || 0),
    0
  );
};

const dropdowns = computed(() => {
  if (!props.filters) {
    return { singleDropdownFilters: {}, multiDropdownFilters: {} };
  }
  const entries = Object.entries(props.filters);

  // split entries into two arrays, one for the filters that should be in a single dropdown, and one for the filters that should be in multiple dropdowns
  const [singleDropdownFilters, multiDropdownFilters] = entries.reduce<[FilterItem, FilterItem]>(
    (acc, [key, value]) => {
      if (showIndividualDropdownForFilter(key)) {
        if (key.includes('year-level')) {
          value = Object.fromEntries(Object.entries(value).sort(([a], [b]) => a.localeCompare(b)));
        }

        acc[0][key] = value;
      } else {
        acc[1][key] = value;
      }
      return acc;
    },
    [{}, {}]
  );
  const facets = getFacetsForLocale(location.value.secondary);
  for (const facet of facets) {
    if (!singleDropdownFilters[facet] && showIndividualDropdownForFilter(facet)) {
      singleDropdownFilters[facet] = {};
    }
  }
  return { singleDropdownFilters, multiDropdownFilters };
});

const numSelectedFiltersForMultiDropdown = computed(() =>
  getNumSelected(...Object.keys(dropdowns.value.multiDropdownFilters))
);

return { __sfc: true,$store, $isFlagOn, location, props, showIndividualDropdownForFilter, getNumSelected, dropdowns, numSelectedFiltersForMultiDropdown, FilterList, DropdownMenu, getFacetDetails }
}

})